// extracted by mini-css-extract-plugin
export var body = "twoColumnBody-module--body--35439";
export var bodyText = "twoColumnBody-module--bodyText--68c5a";
export var gridTextLower = "twoColumnBody-module--gridTextLower--dbf27";
export var left = "twoColumnBody-module--left--99481";